<template>
  <v-app><slot></slot></v-app>
</template>
